import React, { useEffect, useState } from 'react';

const ToastComponent = ({ title, message, type, show, onClose }) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  useEffect(() => {
    let timer;
    if (visible) {
      timer = setTimeout(() => {
        setVisible(false);
        onClose();
      }, 5000); // Automatically close after 5 seconds
    }
    return () => clearTimeout(timer);
  }, [visible, onClose]);

  return (
    <>
      {visible && (
        <div
          className="toast show position-fixed bottom-0 end-0 m-4"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ backgroundColor: 'white', border: '1px solid #ddd' }}
        >
          <div className="toast-header">
            {
              type === 'success' ? (
                <strong className="text-[#05b31c]">{title}</strong>
              ) : (
                <strong className="text-red">{title}</strong>
              )
            }
            
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setVisible(false);
                onClose(); // Callback to close the toast
              }}
              aria-label="Close"
            ></button>
          </div>
          <div className="toast-body">
            {message}
          </div>
        </div>
      )}
    </>
  );
};

export default ToastComponent;
